import { getDoc, doc } from "firebase/firestore";

export default async function firebaseGetDocWrapper(db, collection, id) {
  console.log("In firebaseGetDocWrapper...");

  const docRef = doc(db, collection, id);

  // Deliberately does NOT catch. A read that fails must not become the same
  // null this returns for "no such document": firebaseOnAuthStateChangedWrapper
  // reads null as "first-time user" and calls initializeUser, which would reset
  // a returning user's progress to all questions unanswered. Callers that can
  // tolerate a missing document catch for themselves.
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    // console.log("Document data:", docSnap.data());
    return docSnap.data();
  } else {
    // docSnap.data() will be undefined in this case
    console.log(`No document with doc id ${id} in collection ${collection}!`);
    return null;
  }
}
